/** Stash optimistic user-message ids for the outgoing session. */
export function stashPendingUserMessageIdsForSession(
  bySession: Map<string, string[]>,
  sessionKey: string,
  pendingIds: readonly string[],
): void {
  const key = sessionKey.trim();
  if (!key) {
    return;
  }
  bySession.set(key, [...pendingIds]);
}

/** Restore optimistic user-message ids when activating a session. */
export function restorePendingUserMessageIdsForSession(
  bySession: ReadonlyMap<string, string[]>,
  sessionKey: string,
): string[] {
  const key = sessionKey.trim();
  if (!key) {
    return [];
  }
  return [...(bySession.get(key) ?? [])];
}
